import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { AdminFormGroup, ICompany } from "@myapp/features/admin/models";

export class CompanyForm extends AdminFormGroup {
  id = this.get('id') as FormControl;
  name = this.get('name') as FormControl;
  description = this.get('description') as FormControl;
  isActive = this.get('isActive') as FormControl;

  constructor(readonly company: ICompany, readonly fb: FormBuilder = new FormBuilder()) {
    super(fb.group({
      id: [company?.id, Validators.required],
      name: [company?.name, Validators.required],
      description: [company?.description],
      isActive: [company?.isActive]
    }).controls);

  }

  getItem(): ICompany {

    var company = {
      id: this.id.value,
      name: this.name.value,
      description: this.description.value,
      isActive: this.isActive.value
    };

    return company;
  }

}
